<script>
import abstractField from '../abstractField';
import { h, resolveComponent } from 'vue';

export default {
  name: 'field-checkboxlist',
  mixins: [abstractField],
  computed: {
    items() {
      let values = this.schema.values;
      return values;
    }
  },
  methods: {
    onChange($event) {
      this.schema.onChange(this.model, this.schema, $event);
      this.value = $event;
    }
  },
  render() {
    const legoCheckbox = resolveComponent('lego-checkbox');
    const legoCheckboxWrapper = resolveComponent('lego-checkbox-wrapper');
    const checkboxItem = this.items.map((item, idx) => {
      return h(
        legoCheckbox,
        {
          id: `${this.schema.id}-${idx}`,
          disabled: this.schema.disabled,
          value: item
        },
        [item]
      );
    });

    return h(
      legoCheckboxWrapper,
      {
        values: this.value,
        checked: this.value,
        disabled: this.schema.disabled,
        onInput: this.onChange
      },
      [checkboxItem]
    );
  }
};
</script>
<style lang="scss">
.c-form-group {
  .field-checklist {
    padding-top: 6px;
  }
}
</style>
